exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-center[data-v-e4baf2ce]{margin:20px auto}.spinner[data-v-e4baf2ce]:after{background:#ff0002!important}a[data-v-e4baf2ce],a[data-v-e4baf2ce]:hover{color:#212529}a.text-categories-red[data-v-e4baf2ce],a.text-categories-red[data-v-e4baf2ce]:hover{color:#ff0004}div.blog-categories[data-v-e4baf2ce]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4baf2ce","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/slider_blog.vue
// module id = VAia
// module chunks = 0